import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { toKeyValObject } from '@/utils/state_helpers'
import { useMessagesStore } from '@/stores/messages'

export const useWebCategoriesStore = defineStore('webCategories', {
  state: () => ({
    webCategories: [],
    fetchInitiated: false
  }),

  getters: {
    enabled({ webCategories }) {
      return webCategories.filter(
        ({ enabled }) => enabled === true
      )
    },

    allAsObject() {
      return toKeyValObject(this.enabled, 'title', 'id')
    },

    forIds: ({ webCategories }) => (ids) => {
      return webCategories.filter(({ id }) => ids.includes(id))
    }
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/web_categories')
        .then(response => {
          this.webCategories = response.data.web_categories
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    }
  }
})
